<template>
    <div class="curtain-grey">
        <TimeSingle v-if="timeSingleState"
                    :startTime="singleTime.startTime"
                    :endTime="singleTime.endTime"
                    @closeEvent="switchTime"
                    @submitEvent="saveTimeSingle"
        />
        <TimeCross v-if="timeCrossState"
                   :startDate="startDateStr"
                   :endDate="crossEndDateStr"
                   :startTime="crossTime.startTime"
                   :endTime="crossTime.endTime"
                   @closeEvent="switchTime"
                   @submitEvent="saveTimeCross"
        />
        <div class="body-datetime" v-show="!timeSingleState && !timeCrossState">
            <div class="border-datetime">
                <div class="row-title">
                    <div class="text-clear my-cursor" @click.stop="clearDate">清除</div>
                    <div class="icon-prev my-cursor" @click.stop="prevMonth"></div>
                    <div class="icon-next my-cursor" @click.stop="nextMonth"></div>
                    <div class="text-today my-cursor" @click.stop="todayMonth">今</div>

                    <div class="text-title">
                        {{ solarMonth.toFullString() }}
                    </div>
                </div>
                <div class="row-type-items">
                    <div class="item-type my-cursor"
                         :class="{'item-selected': dateType === 0}"
                         @click.stop="setTypeItem(0)">
                        单天
                    </div>
                    <div class="item-type my-cursor"
                         :class="{'item-selected': dateType === 1}"
                         @click.stop="setTypeItem(1)">
                        跨天
                    </div>
                </div>
                <DateSingle ref="date-single" v-show="dateType === 0"
                            :todayStr="todayStr"
                            :startDate="startDateStr"
                            @submitEvent="saveDateSingle($event)"
                />
                <DateCross ref="date-cross" v-show="dateType === 1"
                           :todayStr="todayStr"
                           :startDate="startDateStr"
                           :endDate="crossEndDateStr"
                           @submitEvent="saveDateCross($event)"
                />
                <div class="row-time" >
                    <div class="icon-time"></div>
                    <div class="text-time-tip">时间</div>
                    <div class="text-time my-cursor" @click.stop="switchTime">
                        {{ textTime }}
                        <span style="color: #999999" v-if="dateType === 1
                        && startDateStr === crossEndDateStr
                        && crossTime.startTime > -1">结束日期</span>
                    </div>
                    <div class="icon-put-away" v-if="textTime==='无'"></div>
                    <div class="icon-clear my-cursor" v-else @click.stop="clearTime"></div>
                </div>
                <div class="button-items">
                    <div class="button-close my-cursor" @click.stop="close">取消</div>
                    <div class="button-submit my-cursor" @click.stop="submit">保存</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DateSingle from "./DateSingle";
import DateCross from "./DateCross";
import TimeSingle from "./TimeSingle";
import TimeCross from "./TimeCross";
export default {
    name: "SettingDateTime",
    components: {
        DateSingle,
        DateCross,
        TimeSingle,
        TimeCross,
    },
    data(){
        return {
            timeSingleState: false,
            timeCrossState: false,
            weekItems: ["一", "二", "三", "四", "五", "六", "日"],
            todayStr: "",
            todayMonthStr: "",
            solarMonth: SolarMonth.fromDate(new Date()),
            startDateStr: "",
            crossEndDateStr: "",
            dateType: -1,
            dateDom: {},

            singleTime: {
                startTime: -1,
                endTime: -1,
            },
            crossTime: {
                startTime: -1,
                endTime: -1,
            },
            textTime: "无",
        }
    },
    props: {
        startDate: {
            type: String,
            default: "",
        },
        crossEndDate: {
            type: String,
            default: "",
        },
        startTime: {
            type: Number,
            default: -1,
        },
        endTime: {
            type: Number,
            default: -1,
        },
        allowCross: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(){
            if(this.dateType === 1 && this.startDateStr === this.crossEndDateStr){
                this.$PopupToast("未选结束日期");
                return
            }
            let timeItem, crossDays;
            if(this.dateType === 0){
                timeItem = this.singleTime;
                crossDays = 0;
            }else{
                timeItem = this.crossTime;
                crossDays = this.$Utils.getIntervalDays(this.startDateStr, this.crossEndDateStr);
            }
            this.$emit("submitEvent", {
                startDate: this.startDateStr,
                crossEndDate: this.crossEndDateStr,
                crossDays: crossDays,
                startTime: timeItem.startTime,
                endTime: timeItem.endTime,
            });
            this.close();
        },
        switchTime: function(){
            if(this.dateType === 0){
                this.timeSingleState = !this.timeSingleState;
            }else{
                this.timeCrossState = !this.timeCrossState;
            }
        },
        clearDate: function(){
            this.startDateStr = "";
            this.crossEndDateStr = "";
            this.dateDom.clearDate();
            this.clearTime();
        },
        prevMonth: function(){
            this.solarMonth = this.solarMonth.next(-1);
            this.dateDom.updateDayItems(this.solarMonth);
        },
        nextMonth: function(){
            this.solarMonth = this.solarMonth.next(1);
            this.dateDom.updateDayItems(this.solarMonth);

        },
        todayMonth: function(){
            this.solarMonth = SolarMonth.fromDate(new Date());
            this.dateDom.updateDayItems(this.solarMonth);
        },
        setYearMonth: function(){
            const yearMonth = this.titleDate.match(/\d+/g);
            const solarCurrent = SolarMonth.fromYm(parseInt(yearMonth[0]), parseInt(yearMonth[1])).next(-1);
            this.titleDate = solarCurrent.getYear() + "年" + solarCurrent.getMonth() + "月";
        },
        setTypeItem: function(dateType){
            let solarDate;
            if(this.dateType === dateType){
                return
            }
            if(dateType === 0){
                // 单日
                if(this.startDateStr === ""){
                    this.startDateStr = this.todayStr;
                }
                this.crossEndDateStr = "";
                solarDate = Solar.fromDate(new Date(this.startDateStr));

                this.dateDom = this.$refs["date-single"];

            }else{
                // 跨天
                if(!this.allowCross){
                    // 弹窗Vip
                    this.$PopupToast("非会员只能创建1条跨天清单");
                    return
                }
                solarDate = Solar.fromDate(new Date(this.startDateStr));
                // 切换跨天
                if(this.crossEndDateStr === ""){
                    this.crossEndDateStr = solarDate.next(1).toYmd();
                }
                this.dateDom = this.$refs["date-cross"];
            }
            this.solarMonth = SolarMonth.fromYm(solarDate.getYear(), solarDate.getMonth());
            setTimeout(()=>{
                this.dateDom.updateDayItems(this.solarMonth);
                this.dateType = dateType;
                this.setTextTime();
            })

        },
        saveDateSingle: function(e){
            this.startDateStr = e
        },
        saveDateCross: function(e){
            this.startDateStr = e[0];
            this.crossEndDateStr = e[1];
            this.setTextTime();
        },
        setTextTime: function(){
            let textTime;
            if(this.dateType === 0){

                if(this.singleTime.startTime === -1){
                    // 无
                    textTime = "无";
                }else if(this.singleTime.endTime === -1){
                    // 时间点
                    const time = this.$Utils.minuteToTime(this.singleTime.startTime);
                    textTime = time.hour + ":" + time.minute;
                }else{
                    // 时间段
                    const startTime = this.$Utils.minuteToTime(this.singleTime.startTime);
                    const endTime = this.$Utils.minuteToTime(this.singleTime.endTime);
                    textTime = startTime.hour + ":" + startTime.minute + "-" + endTime.hour + ":" + endTime.minute;
                }
            }else{

                if(this.crossTime.startTime === -1){
                    textTime = "无";
                }else{
                    const startTime = this.$Utils.minuteToTime(this.crossTime.startTime);
                    const endTime = this.$Utils.minuteToTime(this.crossTime.endTime);
                    textTime = this.$Utils.getDateStr(this.startDateStr) + startTime.hour + ":" + startTime.minute
                        + "-";
                    if(this.startDateStr !== this.crossEndDateStr){
                        textTime = textTime + this.$Utils.getDateStr(this.startDateStr) + endTime.hour + ":" + endTime.minute;
                    }
                }
                console.log("设置时间:", this.crossTime, textTime);

            }
            this.textTime = textTime;
        },
        saveTimeSingle: function(e){
            let startTime, endTime;
            if(e.timeType === "point"){
                startTime = parseInt(e.point.hour) * 60 + parseInt(e.point.minute);
                endTime = -1;
            }else{
                startTime = parseInt(e.slot.start.hour) * 60 + parseInt(e.slot.start.minute);
                endTime = parseInt(e.slot.end.hour) * 60 + parseInt(e.slot.end.minute);
            }
            this.singleTime.startTime = startTime;
            this.singleTime.endTime = endTime;
            this.setTextTime();
        },
        saveTimeCross: function(e){
            this.crossTime.startTime = parseInt(e.start.hour) * 60 + parseInt(e.start.minute);
            this.crossTime.endTime = parseInt(e.end.hour) * 60 + parseInt(e.end.minute);
            this.setTextTime();
        },
        clearTime: function(){
            if(this.dateType === 0){
                this.singleTime.startTime = -1;
                this.singleTime.endTime = -1;
            }else{
                this.crossTime.startTime = -1;
                this.crossTime.endTime = -1;
            }
            this.setTextTime();
        }
    },
    mounted(){
        // 初始化时间
        const todayObj = Solar.fromDate(new Date());
        this.todayStr = todayObj.toString();
        this.todayYearMonth = todayObj.getYear() + "年" + todayObj.getMonth() + "月";
        // 初始化日期
        let solarDate, dateType;
        if(this.startDate === ""){
            // 待办 无日期
            this.startDateStr = this.todayStr;
            dateType = 0;
        }else if(this.crossEndDate === ""){
            // 单日
            this.startDateStr = this.startDate;
            dateType = 0;
        }else{
            // 跨天
            this.startDateStr = this.startDate;
            this.crossEndDateStr = this.crossEndDate;
            dateType = 1;
        }
        solarDate = Solar.fromDate(new Date(this.startDateStr));
        this.solarMonth = SolarMonth.fromYm(solarDate.getYear(), solarDate.getMonth());
        this.dateType = dateType;
        // 获取日期对象
        if(dateType === 0){
            this.dateDom = this.$refs["date-single"];
            this.singleTime.startTime = this.startTime;
            this.singleTime.endTime = this.endTime;
        }else{
            this.dateDom = this.$refs["date-cross"];
            this.crossTime.startTime = this.startTime;
            this.crossTime.endTime = this.endTime;
        }
        setTimeout(()=>{
            this.dateDom.updateDayItems(this.solarMonth);
        })
        this.setTextTime();

    },
}
</script>

<style scoped>
div.body-datetime{
    width: 4.2rem;
    height: auto;
    padding: 0.08rem;
    background: #FFFFFF;
    border-radius: 0.3rem;
    margin: 20vh auto auto;
}

div.border-datetime{
    width: 100%;
    height: auto;
    padding: 0.16rem 0.2rem 0.3rem;
    border: 0.02rem solid #000000;
    border-radius: 0.26rem;
    box-sizing: border-box;
}

div.row-title{
    height: 0.22rem;
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
    position: relative;
}

div.text-clear, div.text-today{
    position: absolute;
    color: #FC8470;
}
div.text-clear{
    left: 0;
}
div.text-today{
    right: 0;
}
div.icon-prev, div.icon-next{
    width: 0.16rem;
    height: 0.16rem;
    position: absolute;
    top: 0.03rem;
}
div.icon-prev{
    background: url("../../../assets/images/Public/icon-prev.png");
    background-size: cover;
    left: 0.9rem;
}
div.icon-next{
    background: url("../../../assets/images/Public/icon-next.png");
    background-size: cover;
    right: 0.9rem;
}




div.row-type-items{
    width: 100%;
    margin: 0.24rem 0 0.18rem;
    display: flex;
    justify-content: space-between;
    padding: 0 0.6rem;
    box-sizing: border-box;
}
div.item-type{
    width: 1rem;
    height: 0.4rem;

    font-size: 0.18rem;
    color: #000000;
    line-height: 0.36rem;
    text-align: center;

    border-radius: 0.2rem;
    border: 0.02rem solid #000000;
    box-sizing: border-box;
}
div.item-selected{
    background: #000000;
    color: #FFFFFF;
}
div.row-time{
    width: 100%;
    height: 0.3rem;
    display: flex;
    align-items: center;
    gap: 0.1rem;
    margin-top: 0.16rem;

    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
}
div.icon-time{
    width: 0.24rem;
    height: 0.24rem;
    background: url("../../../assets/images/List/icon-time.png");
    background-size: cover;
}
div.text-time-tip{
    text-align: left;
}
div.text-time{
    text-align: right;
    flex: 1;
}
div.icon-put-away{
    width: 0.14rem;
    height: 0.14rem;
    background: url("../../../assets/images/List/icon-put-away.png");
    background-size: cover;
}
div.icon-clear{
    width: 0.18rem;
    height: 0.18rem;
    background: url("../../../assets/images/Public/icon-clear.png");
    background-size: cover;
}

div.button-items{
    width: 100%;
    height: 0.48rem;
    margin-top: 0.4rem;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
}
div.button-submit, div.button-close{
    width: 1.4rem;
    height: 0.48rem;
    border-radius: 0.38rem;
    border: 0.02rem solid #000000;
    font-size: 0.16rem;
    line-height: 0.43rem;
    text-align: center;
}

div.button-close{
    background: #FFFFFF;
    box-shadow: inset 0 -0.05rem 0 0 #9F9F9F;
    color: #000000;
}
div.button-submit{
    background: #FC8470;
    box-shadow: inset 0 -0.05rem 0 0 #FFF4C9;
    color: #FFFFFF;
}
</style>